import { getKyClient } from './client';

export const fetchFacilityById = async (facilityId) => {
  const url = `v1.0/facilities/${facilityId}`;
  const kyClient = await getKyClient();
  return await kyClient.get(url).json();
};
